module.exports = __webpack_public_path__ + "static/img/134.02a1ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/134.jpg
// module id = JU2x
// module chunks = 0